/**
 * @author xyguo
 * @description 组合报表管理=>报表详情
 * @Date 2021/06/21
 */
import React from "react";
import { connect } from "dva";
import { framework_tool,utils_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from "./column";
import { mapStateToProps, handleExport } from "../../utils";

const { WizContainer, WizReduxTemplate } = framework_tool;
let {Session} = utils_tool

class ReportConfigDetailList extends WizContainer {
  componentName = "ReportConfigDetailList";

  constructor(props) {
    super(props);
    this.state = {}
    const {history} = props
    let reportConfigDetaiInfo = {}
    if (history.location && history.location.pathname === '/dataReport/reportConfigList/reportConfigDetailList') {
      if (history.location && history.location.record) {
        reportConfigDetaiInfo = history.location.record
        Session.set('reportConfigDetaiInfo', reportConfigDetaiInfo)
      } else {
        reportConfigDetaiInfo = Session.get('reportConfigDetaiInfo') || {}
      }
    }
    this.reportConfigDetaiInfo = reportConfigDetaiInfo
  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this,this.reportConfigDetaiInfo),
      apiDataFormat: {
        export: handleExport.bind(this, { title: "报表详情", column }),
      },
      reportConfigId : this.reportConfigDetaiInfo.id
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />;
  }
}

export default connect(
  mapStateToProps.bind(this, {
    nameSpace: "reportConfig",
    method: "getDetailListByPage",
  })
)(ReportConfigDetailList);
